import { UPDATE_LIST_DESCRIPTION_ENDPOINT } from 'api/ListsApi';
import { useRestMutation } from 'utils/hooks/api/useRestMutation';
import { useToastNotification } from 'utils/hooks/useToastNotification';
import { useTranslation } from './useTranslation';
import { UpdateListDescriptionParams, UpdateListDescriptionSuccessResponse } from '../types';
import { useListDetailsContext } from '../contexts/listDetails';

export const useUpdateListDescriptionMutation = (emailListId?: number) => {
  const { t } = useTranslation();
  const { refetch } = useListDetailsContext();

  const { mutate, data, isSuccess, isLoading, isError } = useRestMutation<
    UpdateListDescriptionSuccessResponse,
    UpdateListDescriptionParams
  >(UPDATE_LIST_DESCRIPTION_ENDPOINT);

  const updateListDescription = (description: string) => {
    if (emailListId) {
      return mutate({ emailListId, description }, { onSuccess: () => refetch() });
    }
  };

  useToastNotification({
    enabled: !isLoading && !!data,
    positive: isSuccess,
    positiveMessage: data,
  });

  useToastNotification({
    enabled: !isLoading && isError,
    negative: isError,
    negativeMessage: t('toast.listDescriptionNegative', { emailListId }),
  });

  return { updateListDescription };
};
